<template>
  <div class="autobookpro-page-content">
    <div class="row items-start q-mb-lg">
      <div class="text-h5">
        <q-icon name="card_travel" />
        Convert into
        <span v-if="isQuoteContext">Order ID:</span>
        <span v-if="isOrderContext">Quote ID:</span>
        <span class="text-bold"> #{{ id }}</span>
      </div>
      <div class="col-grow row justify-end">
        <q-btn
          color="primary"
          label="Convert"
          @click="handleConvert"
          :loading="converting"
        />
      </div>
    </div>
    <q-separator class="q-my-sm" />

    <div class="q-mb-md row justify-between">
      <div class="row q-gutter-x-sm">
        <q-select
          style="width: 250px"
          dense
          use-input
          label="Status"
          v-model="parentStatus"
          :options="parentStatusOptions"
          option-label="name"
          option-value="id"
          :loading="loadingParentStatus"
          @filter="filterParentStatusFn"
          :error="$v.parentStatus.$error"
          :hide-bottom-space="true"
          v-bind="rRGetqSelectBrand('style1')"
        />
        <q-select
          style="min-width: 250px"
          class="q-mx-sm"
          dense
          use-input
          label="Child Status"
          v-model="childStatus"
          :options="childStatusOptions"
          option-label="name"
          option-value="id"
          :loading="loadingChildStatus"
          @filter="filterChildStatusFn"
          v-bind="rRGetqSelectBrand('style1')"
        />
      </div>
      <div class="row q-gutter-x-sm">
        <q-select
          dense
          style="min-width: 250px"
          v-model="referrerId"
          label="Referrer"
          option-value="id"
          option-label="name"
          :options="referrers"
          emit-value
          map-options
          v-bind="rRGetqSelectBrand('style1')"
        />
        <q-select
          dense
          style="min-width: 250px"
          v-model="assignee"
          label="Assignee"
          :options="assignees"
          option-value="id"
          :option-label="(item) => `${item.firstName} ${item.lastName}`"
          @input="delayTouch($v.assignee, $options.touchMap)"
          :error="$v.assignee.$error"
          :hide-bottom-space="true"
          v-bind="rRGetqSelectBrand('style1')"
        />
      </div>
    </div>
    <div class="row q-col-gutter-sm">
      <div class="col-md-8 col-sm-12 q-col-gutter-y-sm">
        <div class="row q-col-gutter-sm">
          <div :class="`${isOrderContext ? 'col-12' : 'col'}`">
            <app-customer-info-card
              :context="`${isQuoteContext ? 'order' : 'quote'}`"
              action="edit"
              v-model="shipper"
              :validation="$v.shipper"
            />
          </div>
        </div>
        <div class="row q-col-gutter-sm">
          <div class="col">
            <app-location-filterable-card
              :context="`${isQuoteContext ? 'order' : 'quote'}`"
              action="edit"
              label="Origin"
              v-model="origin"
              @input="handleLocationChange('origin')"
              :validation="$v.origin"
            >
              <template #header>
                <q-btn
                  icon="person"
                  round
                  flat
                  size="sm"
                  class="q-icon-btn"
                  @click="assignLocationPerson('origin')"
                />
              </template>
            </app-location-filterable-card>
          </div>
          <div class="col">
            <app-location-filterable-card
              :context="`${isQuoteContext ? 'order' : 'quote'}`"
              action="edit"
              label="Destination"
              v-model="destination"
              @input="handleLocationChange('destination')"
              :validation="$v.destination"
            >
              <template #header>
                <q-btn
                  icon="person"
                  round
                  flat
                  size="sm"
                  class="q-icon-btn"
                  @click="assignLocationPerson('destination')"
                />
              </template>
            </app-location-filterable-card>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-vehicle-details-card
              :context="`${isQuoteContext ? 'order' : 'quote'}`"
              action="edit"
              v-model="vehicles"
              :validation="$v.vehicles"
            />
          </div>
        </div>

        <!-- <div class="q-ma-sm">
          <app-google-map-view-location
            :type="['edit', 'quote']"
            :origin="origin"
            :destination="destination"
          />
        </div> -->
      </div>
      <div class="col-md-4 col-sm-12 q-col-gutter-y-sm">
        <div>
          <app-transport-pricing-card
            :context="`${isQuoteContext ? 'order' : 'quote'}`"
            v-model="transport"
            :running-taq="runningTAQ"
            :validation="$v.transport"
            @run-taq="handleRunTAQ"
          />
        </div>
        <div>
          <app-transport-info-card
            ref="transportInfoCardRef"
            :context="`${isQuoteContext ? 'order' : 'quote'}`"
            action="edit"
            v-model="transport"
            :validation="$v.transport"
          />
        </div>

        <div>
          <app-internal-notes-card
            context="quote"
            action="edit"
            title="Notes"
            v-model="internalNotes"
          />
        </div>

        <!-- <div>
          <app-doc-image-uploader-card :data="quote.id" />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { orderValidator, quoteValidator } from '@client/validators';
import graphql from '@client/graphql';
import {
  extractKeysIntoObject,
  sanitizeObject
} from '@client/utils/object-helpers';
import AppCustomerInfoCard from '@client/components/cards/customer-info-card';
import AppLocationFilterableCard from '@client/components/cards/location-filterable-card';
import AppVehicleDetailsCard from '@client/components/cards/vehicle-details-card';
import AppTransportInfoCard from '@client/components/cards/transport-info-card';
import AppTransportPricingCard from '@client/components/cards/transport-pricing-card';
import AppInternalNotesCard from '@client/components/cards/internal-notes-card';
// import AppGoogleMapViewLocation from '@client/components/cards/google-map-view-location';
// import AppDocImageUploaderCard from '@client/components/cards/doc-image-uploader-card';
import { rrFormatPhoneNumber } from '@client/utils/app-helpers';

export default {
  name: 'AppConvertToOrder',
  metaInfo() {
    let title = 'Convert to Order';
    if (this.isOrderContext) title = 'Convert to quote';

    return { title };
  },
  graphql,
  components: {
    AppCustomerInfoCard,
    AppLocationFilterableCard,
    AppVehicleDetailsCard,
    AppTransportInfoCard,
    AppTransportPricingCard,
    AppInternalNotesCard
    // AppGoogleMapViewLocation,
    // AppDocImageUploaderCard,
  },
  validations() {
    let validator = null;

    if (this.isOrderContext) validator = quoteValidator;
    validator = orderValidator;

    return {
      ...validator,
      parentStatus: { required }
    };
  },
  apollo: {
    quote() {
      let gql = graphql.queries.getQuote;
      if (this.isOrderContext) gql = graphql.queries.getOrder;

      return {
        query: gql,
        variables() {
          return { id: this.theQuoteId };
        },
        watchLoading(isLoading) {
          this.loading = isLoading;
        },
        error(error) {
          this.error = error;
        },
        update(data) {
          if (this.isQuoteContext) return data.quote;
          return data.order;
        },
        result(result) {
          if (result.loading) return;

          let theQuote = result.data.quote;
          if (this.isOrderContext) theQuote = result.data.order;
          Object.assign(this, theQuote);

          this.origin.phone = this.origin.phone || '';
          this.destination.phone = this.destination.phone || '';
        }
      };
    },
    parentStatuses: {
      query: graphql.queries.getParentStatus,
      variables() {
        if (this.isOrderContext) return { type: 'QUOTE' };
        return { type: 'ORDER' };
      },
      watchLoading(isLoading) {
        this.loadingParentStatus = isLoading;
      },
      result(result) {
        if (result.loading) return;

        if (this.isOrderContext) {
          this.parentStatus = result.data.parentStatuses.find(
            (status) => status.id === window.DEFAULT_QUOTE_STATUS_ID
          );
        } else {
          this.parentStatus = result.data.parentStatuses.find(
            (status) => status.id === window.DEFAULT_ORDER_STATUS_ID
          );
        }
      }
    },
    assignees: {
      query: graphql.queries.loadAssignees
    },
    referrers() {
      return {
        query: graphql.queries.getReferrers,
        async result(result) {
            if (result.loading) return;
            const { referrers } = result.data;
            Object.assign(this, referrers);
            this.referrer = referrers?.[0]?.id;
          }
      };
    }
  },
  // beforeMount() {
  //   const preventNav = (event) => {
  //     if (Object.keys(this.dirty).length > 0) {
  //       event.preventDefault();
  //       // eslint-disable-next-line no-param-reassign
  //       event.returnValue = '';
  //     }
  //   };

  //   window.addEventListener('beforeunload', preventNav);
  //   this.$once('hook:beforeDestroy', () => {
  //     window.removeEventListener('beforeunload', preventNav);
  //   });
  // },
  // beforeRouteLeave(to, from, next) {
  //   if (Object.keys(this.dirty).length > 0) {
  //     this.$q
  //       .dialog({
  //         title: 'Confirm',
  //         message:
  //           'Changes you made may not be saved. Are you sure you want to leave?',
  //         cancel: true,
  //         persistent: true
  //       })
  //       .onOk(() => {
  //         next();
  //       })
  //       .onCancel(() => {
  //         next(false);
  //       });
  //   } else {
  //     next();
  //   }
  // },
  data() {
    return {
      loading: false,
      error: null,
      id: null,

      parent: null,

      referrerId: null,

      assignee: null,

      loadingParentStatus: false,
      parentStatus: null,
      parentStatusOptions: [],

      loadingChildStatus: false,
      childStatus: null,
      childStatusOptions: [],

      shipper: {},
      origin: {
        phone: ''
      },
      destination: {
        phone: ''
      },
      vehicles: [
        {
          year: null,
          make: null,
          model: null,
          size: {
            id: null,
            name: ''
          }
        }
      ],

      runningTAQ: false,
      transport: {},

      internalNotes: [],

      converting: false
    };
  },
  computed: {
    theQuoteId() {
      return this.$route.params.id;
    },
    isQuoteContext() {
      return this.$route.name === 'convert-to-order';
    },
    isOrderContext() {
      return this.$route.name === 'convert-to-quote';
    }
  },
  methods: {
    handleLocationChange() {
      if (!this.origin.zipcode || !this.destination.zipcode) return;

      if (this.quote.origin.zipcode !== this.origin.zipcode) {
        this.$refs.transportInfoCardRef.calcDistance(
          this.origin.zipcode,
          this.destination.zipcode
        );
      } else if (this.quote.destination.zipcode !== this.destination.zipcode) {
        this.$refs.transportInfoCardRef.calcDistance(
          this.origin.zipcode,
          this.destination.zipcode
        );
      }
    },
    filterParentStatusFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.parentStatusOptions = this.parentStatuses.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterChildStatusFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.childStatusOptions = this.parentStatuses
          .find((s) => s.id === this.parentStatus.id)
          .children.filter((v) => v.name.toLowerCase().indexOf(needle) > -1);
      });
    },

    assignLocationPerson(modelName) {
      const model = this[modelName];
      model.name = this.shipper.firstName;
      model.phone = this.shipper.phone &&
        this.shipper.phone.substring(0, 2) === '+1'
          ? this.shipper.phone.substring(2)
          : this.shipper.phone;
      model.phone2 = this.shipper.phone2 &&
        this.shipper.phone2.substring(0, 2) === '+1'
          ? this.shipper.phone2.substring(2)
          : this.shipper.phone2;
    },
    async handleRunTAQ() {
      this.validate(['origin', 'destination', 'vehicles']);

      this.runningTAQ = true;

      try {
        const response = await this.$apollo.mutate({
          mutation: graphql.mutations.runTransportAutoQuoter,
          variables: {
            origin: this.origin,
            destination: this.destination,
            vehicles: this.vehicles,
            carrierType: this.transport.carrierType,
            referrerId: this.referrerId ? this.referrerId : null
          }
        });
        const { runTransportAutoQuoter } = response.data;
        this.transport = {
          ...this.transport,
          ...runTransportAutoQuoter
        };
      } catch (error) {
        this.notifyNegative(error.message);
      }

      this.runningTAQ = false;
    },
    async convertToOrder() {
      const inputData = extractKeysIntoObject(this, [
        'assignee',
        'referrerId',
        'parentStatus',
        'childStatus',
        'shipper',
        'origin',
        'destination',
        'vehicles',
        'transport',
        'internalNotes'
      ]);

      inputData.origin = {
                          ...inputData.origin,
                          phone: rrFormatPhoneNumber(inputData.origin?.phone),
                          phone2: rrFormatPhoneNumber(inputData.origin?.phone2)
                        };
      inputData.destination = {
                          ...inputData.destination,
                          phone: rrFormatPhoneNumber(inputData.destination?.phone),
                          phone2: rrFormatPhoneNumber(inputData.destination?.phone2)
                        };

      const input = {
        assigneeId: parseInt(inputData.assignee.id, 10),
        referrerId: inputData.referrerId ? Number(inputData.referrerId) : null,
        parentStatusId: parseInt(inputData.parentStatus.id, 10),
        childStatusId: inputData.childStatus
          ? parseInt(inputData.childStatus.id, 10)
          : null,
        shipper: sanitizeObject(inputData.shipper),
        origin: sanitizeObject(inputData.origin),
        destination: sanitizeObject(inputData.destination),
        transport: extractKeysIntoObject(inputData.transport, [
          'miles',
          'carrierType',
          'availableDate',
          'deliveryDate',
          'basePrice',
          'sizeFee',
          'inopFee',
          'enclosedFee',
          'deposit'
        ]),
        vehicles: inputData.vehicles
          .map((v) => sanitizeObject(v))
          .map(({ size, ...v }) => {
            if (size) return { ...v, sizeId: size.id };
            return v;
          }),
        internalNotes: inputData.internalNotes.map((n) => sanitizeObject(n))
      };

      await this.$apollo.mutate({
        mutation: graphql.mutations.convertToOrder,
        variables: {
          quoteId: this.theQuoteId,
          input
        }
      });
    },
    async convertToQuote() {
      const inputData = extractKeysIntoObject(this, [
        'assignee',
        'referrerId',
        'parentStatus',
        'childStatus',
        'shipper',
        'origin',
        'destination',
        'vehicles',
        'transport',
        'internalNotes'
      ]);

      inputData.origin = {
                          ...inputData.origin,
                          phone: rrFormatPhoneNumber(inputData.origin?.phone),
                          phone2: rrFormatPhoneNumber(inputData.origin?.phone2)
                        };
      inputData.destination = {
                          ...inputData.destination,
                          phone: rrFormatPhoneNumber(inputData.destination?.phone),
                          phone2: rrFormatPhoneNumber(inputData.destination?.phone2)
                        };

      const input = {
        assigneeId: parseInt(inputData.assignee.id, 10),
        referrerId: inputData.referrer ? Number(inputData.referrer) : null,
        parentStatusId: parseInt(inputData.parentStatus.id, 10),
        childStatusId: inputData.childStatus
          ? parseInt(inputData.childStatus.id, 10)
          : null,
        shipper: extractKeysIntoObject(sanitizeObject(inputData.shipper), [
          'firstName',
          'lastName',
          'phone',
          'phone2',
          'email',
          'noText',
          'noEmail'
        ]),
        origin: extractKeysIntoObject(sanitizeObject(inputData.origin), [
          'name',
          'address',
          'zipcode',
          'city',
          'state',
          'phone',
          'phone2'
        ]),
        destination: extractKeysIntoObject(inputData.destination, [
          'name',
          'address',
          'zipcode',
          'city',
          'state',
          'phone',
          'phone2'
        ]),
        transport: extractKeysIntoObject(inputData.transport, [
          'miles',
          'carrierType',
          'availableDate',
          'deliveryDate',
          'basePrice',
          'sizeFee',
          'inopFee',
          'enclosedFee',
          'deposit'
        ]),
        vehicles: inputData.vehicles.map((v) =>
          extractKeysIntoObject(v, ['year', 'make', 'model', 'operable'])
        ),
        internalNotes: inputData.internalNotes.map((n) => sanitizeObject(n))
      };

      await this.$apollo.mutate({
        mutation: graphql.mutations.convertToQuote,
        variables: {
          orderId: this.theQuoteId,
          input
        }
      });
    },
    async handleConvert() {
      this.validate([
        'assignee',
        'parentStatus',
        'shipper',
        'origin',
        'destination',
        'transport',
        'vehicles'
      ]);

      this.converting = true;

      if (this.isQuoteContext) {
        await this.convertToOrder();
      } else {
        await this.convertToQuote();
      }

      this.converting = false;

      if (this.isQuoteContext) {
        this.$router.push({
          name: 'order-detail',
          params: { id: this.id },
          query: { edit: 'true' }
        });
      } else {
        this.$router.push({
          name: 'quote-detail',
          params: { id: this.id },
          query: { edit: 'true' }
        });
      }
    }
  },
  mounted() {
      this.$refs.transportInfoCardRef.calcDistance(
        this.origin.zipcode,
        this.destination.zipcode
      );
  }
};
</script>
